import {CampaignType} from '../campaigns.types';

export function isSocialCampaign(campaignType: CampaignType) {
  return [
    CampaignType.FacebookVideoAds,
    CampaignType.TikTokAds,
    CampaignType.YoutubeVideoAds,
    CampaignType.SnapchatAds,
    CampaignType.LinkedInAds,
    CampaignType.MockSocial,
  ].includes(campaignType);
}
